import React from "react";
import { ArrowRight } from "lucide-react";
import { sustainability as S, topStats } from "../mock";
import useReveal from "../hooks/useReveal";
import { useEnquiry } from "./EnquiryProvider";

/**
 * Capacity board — the numbers a sourcing manager scans for, made the
 * loudest thing on the page: display numerals, one line of context each.
 */
const BOARD = [
  { num: "4,00,000", unit: "pcs / month", label: "Knits capacity", note: "500 seats across 15 units" },
  { num: "80,000", unit: "pcs / month", label: "Shirts capacity", note: "7-seam fully taped capability" },
  { num: "30+", unit: "years", label: "Manufacturing for export", note: "Established 1998, Andheri (East)" },
  { num: "3", unit: "factories", label: "Mumbai · Umargam · Tiruppur", note: "Knits and wovens under one roof" },
  { num: "ISO", unit: "14001 : 2015", label: "Environment management", note: "TUV Austria certified" },
  { num: "6", unit: "regions", label: "UK · Turkey · GCC · LatAm · USA · South Africa", note: "Brands on four continents" },
];

export default function CapacityBoard() {
  const [ref, inView] = useReveal();
  const enquiry = useEnquiry();

  return (
    <section id="capacity" className="kse-section kse-section--dark bg-[#0d1640] text-white overflow-hidden">
      <div className="kse-container">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <p className="kse-eyebrow kse-eyebrow--light">Capacity at a glance</p>
            <h2 className="kse-h2 kse-h2--light max-w-2xl">The numbers a sourcing team asks for first.</h2>
          </div>
          <p className="text-blue-100/70 max-w-md lg:text-right">
            {topStats[3].value} skilled people, every stage in-house &mdash; merchandising, sampling, production,
            logistics and documentation.
          </p>
        </div>

        <div ref={ref} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 rounded-3xl overflow-hidden">
          {BOARD.map((b, i) => (
            <div
              key={b.label}
              className={`bg-[#0d1640] p-7 sm:p-8 reveal ${inView ? "in-view" : ""}`}
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="kse-num text-5xl sm:text-6xl lg:text-7xl text-white">{b.num}</span>
                <span className="text-blue-200 text-sm font-semibold tracking-wide">{b.unit}</span>
              </div>
              <div className="mt-3 text-white font-bold">{b.label}</div>
              <div className="text-blue-100/60 text-sm mt-1">{b.note}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4">
          <button onClick={() => enquiry?.openEnquiry()} className="kse-btn kse-btn--accent self-start">
            Check capacity for your order <ArrowRight size={16} />
          </button>
          <p className="text-blue-100/60 text-sm max-w-xl">{S.desc}</p>
        </div>
      </div>
    </section>
  );
}
